module.exports = __webpack_public_path__ + "dingbeauty-landing/img/fb.380ee34d.svg";